import { cn } from "@/frontend/lib/utils";

/** Stateless pill-style multiselect over a fixed `options` list. Caller owns
 *  the selected array and re-renders with the next one on each toggle. */
export function PillMultiselect<T extends string>({
  options,
  selected,
  onChange,
  className,
}: {
  options: readonly { value: T; label: string }[];
  selected: readonly T[];
  onChange: (next: T[]) => void;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {options.map(({ value, label }) => {
        const active = selected.includes(value);
        return (
          <button
            key={value}
            type="button"
            onClick={() =>
              onChange(active ? selected.filter((v) => v !== value) : [...selected, value])
            }
            className={cn(
              "rounded-md border px-2.5 py-1 text-xs transition-colors",
              active
                ? "border-primary bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted",
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
